import type { CreateReagentItemInput, ReagentItemStock } from '#shared/types';

const EMPTY_REAGENT_ITEM: CreateReagentItemInput = {
  name: '',
  code: '',
  barcode: '',
  department_id: 0,
  default_supplier_id: null,
  base_unit: 'test',
  pack_label: '',
  pack_size_base: 1,
  reorder_level_base: 0,
  storage_location: '',
  note: '',
  is_active: true,
};

/** The form's starting values: the saved reagent when editing, blanks when adding. */
export function initialReagentItemValues(record?: ReagentItemStock): CreateReagentItemInput {
  if (!record) return EMPTY_REAGENT_ITEM;
  return {
    name: record.name,
    code: record.code,
    barcode: record.barcode ?? '',
    department_id: record.department_id,
    default_supplier_id: record.default_supplier_id,
    base_unit: record.base_unit,
    pack_label: record.pack_label,
    pack_size_base: record.pack_size_base,
    reorder_level_base: record.reorder_level_base,
    storage_location: record.storage_location ?? '',
    note: record.note ?? '',
    is_active: record.is_active,
  };
}

/**
 * Once stock has moved, the unit and pack size are the meaning of every past
 * receipt. The server refuses to change them; saying so in the form saves a
 * round trip and explains why the fields look frozen.
 */
export function hasStockMoved(record?: ReagentItemStock): boolean {
  return (record?.received_base ?? 0) > 0 || (record?.lot_count ?? 0) > 0;
}
